import { register } from '@forter/core';
import { FcChart } from './FcChart.js';

register(FcChart);
